import { createAction } from 'redux-actions';

import { TOGGLE_MODAL_ALERT, UPDATE_SERVICE_WORKER } from './types';

export const updateServiceWorker = createAction(UPDATE_SERVICE_WORKER);
export const toggleModalAlert = createAction(TOGGLE_MODAL_ALERT);
